import { put, select } from 'redux-saga/effects';
import { actions } from 'react-redux-form';
import {
	ADMIN_DASHBOARD_SEARCH_SUCCESS,
	ADMIN_DASHBOARD_SEARCH_ERROR,
	ADMIN_DASHBOARD_CHANGE_SUCCESS,
	ADMIN_DASHBOARD_CHANGE_ERROR,
	ADMIN_DASHBOARD_INSERT_SUCCESS,
	ADMIN_DASHBOARD_INSERT_ERROR,
	GET_DASHBOARD_OPTIONS_SUCCESS,
	GET_DASHBOARD_OPTIONS_ERROR,
	// GET_ADMIN_CSV,
	GET_ADMIN_CSV_SUCCESS,
	GET_ADMIN_CSV_ERROR,
	RUN_CALCULATIONS_SUCCESS,
	RUN_CALCULATIONS_ERROR,
	GET_TEAM_HEALTH_SCORE_NFL_SUCCESS,
	GET_TEAM_HEALTH_SCORE_NFL_ERROR,
	SEARCH_GAMES,
	SEARCH_GAMES_SUCCESS,
	SEARCH_GAMES_ERROR,
	SUBMIT_ADMIN_CHANGES_SUCCESS,
	SUBMIT_ADMIN_CHANGES_ERROR,
	ADMIN_GET_DFS_PICKS_SUCCESS,
	ADMIN_GET_DFS_PICKS_ERROR,
	ADMIN_SAVE_DFS_PICK_SUCCESS,
	ADMIN_SAVE_DFS_PICK_ERROR,
	ADMIN_DELETE_DFS_PICK_SUCCESS,
	ADMIN_DELETE_DFS_PICK_ERROR,
	ADMIN_SEARCH_DFS_PLAYERS_SUCCESS,
	ADMIN_SEARCH_DFS_PLAYERS_ERROR,
	GET_TBD_PLAYERS,
	GET_TBD_PLAYERS_SUCCESS,
	GET_TBD_PLAYERS_ERROR,
	SET_PLAYER_RETURN_DATE_SUCCESS,
	SET_PLAYER_RETURN_DATE_ERROR,
	CLEAR_PLAYER_RETURN_DATE_SUCCESS,
	CLEAR_PLAYER_RETURN_DATE_ERROR
} from './constants';
import { request, toLocalTime, formatDateWithTime } from '../components/utils';
import * as selectors from './selectors';
import { ADMIN_TOKEN } from '../components/utils/config';
var _ = require('lodash');

export function* adminDashboardOptions() {
	const user = yield select((state) => state.user);
	try {
		const result = yield request({}, `/admin/fetchdashboardoptions/${ADMIN_TOKEN}`, 'GET', user?.token);
		if (result.data.status) {
			// yield put({ type: GET_ADMIN_CSV });
			yield put({
				type: GET_DASHBOARD_OPTIONS_SUCCESS,
				payload: {
					teams: result.data?.data?.teams,
					positions: result?.data?.data?.positions,
					bodyParts: result?.data?.data?.bodyParts,
					users: result?.data?.data?.users
				}
			});
		} else {
			yield put({
				type: GET_DASHBOARD_OPTIONS_ERROR
			});
		}
	} catch (err) {
		console.log(err);
		yield put({
			type: GET_DASHBOARD_OPTIONS_ERROR
		});
	}
}

export function* adminDashboardCSV(action) {
	const user = yield select((state) => state.user);
	try {
		const result = yield request({}, `/admin/dashboardCrawlerInfo/${ADMIN_TOKEN}`, 'GET', user?.token);
		if (result.data.status) {
			yield put({
				type: GET_ADMIN_CSV_SUCCESS,
				payload: {
					csvData: result?.data?.data
				}
			});
		} else {
			yield put({
				type: GET_ADMIN_CSV_ERROR
			});
		}
	} catch (err) {
		console.log(err);
		yield put({
			type: GET_ADMIN_CSV_ERROR
		});
	}
}

export function* adminDashboardSearch() {
	const user = yield select(selectors.user);
	const adminDashboardSearch = yield select(selectors.adminDashboardSearch);
	try {
		console.log(adminDashboardSearch);
		const data = { };
		if (adminDashboardSearch.playerName) {
			data.playerName = adminDashboardSearch.playerName;
		}
		if (adminDashboardSearch.teamId) {
			data.teamId = adminDashboardSearch.teamId;
		}
		if (adminDashboardSearch.sportsID) {
			data.sportsID = adminDashboardSearch.sportsID;
		}
		if (adminDashboardSearch.position) {
			data.position = adminDashboardSearch.position;
		}
		const result = yield request(data, `/admin/searchinfo/${ADMIN_TOKEN}`, 'POST', user?.token);
		if (result.data.status && (result?.data?.data?.info?.length || result?.data?.data?.details || (result?.data?.data?.ircTable?.length && result?.data?.data?.hpfTable?.length))) {
			yield put({
				type: ADMIN_DASHBOARD_SEARCH_SUCCESS,
				payload: {
					info: result?.data?.data?.info,
					details: result?.data?.data?.details,
					ircTable: result?.data?.data?.ircTable,
					hpfTable: result?.data?.data?.hpfTable,
					rawCrawler: result?.data?.data?.rawCrawler,
					convertedCrawler: result?.data?.data?.convertedCrawler,
					teamTable: result?.data?.data?.teamTable,
					schedulesTable: result?.data?.data?.schedulesTable,
					heatmapTable: result?.data?.data?.heatmapTable
				}
			});
		} else {
			yield put({
				type: ADMIN_DASHBOARD_SEARCH_ERROR,
				payload: {
					message: !result?.data?.data?.info?.length && !result?.data?.data?.ircTable?.length && !result?.data?.data?.hpfTable.length ? 'Info not found' : 'There was an error retrieving the information'
				}
			});
		}
	} catch (err) {
		console.log(err);
		yield put({
			type: ADMIN_DASHBOARD_SEARCH_ERROR,
			payload: { message: 'There was an error retrieving the information' }
		});
	}
}

export function* adminDashboardChange() {
	const user = yield select(selectors.user);
	const adminDashboardSearch = yield select(selectors.adminDashboardSearch);
	const playerID = adminDashboardSearch.info[0].player_id;
	try {
		const data = {
			sportsID: adminDashboardSearch.sportsID,
			playerID: playerID,
			adminDashboardChange: adminDashboardSearch.updates
		};
		const result = yield request(data, `/admin/changeinfo/${ADMIN_TOKEN}`, 'POST', user?.token);
		if (result.data.status) {
			yield put({
				type: ADMIN_DASHBOARD_CHANGE_SUCCESS,
				payload: { message: 'Changes submitted successfully!' }
			});
		} else {
			yield put({
				type: ADMIN_DASHBOARD_CHANGE_ERROR,
				paylod: { message: 'There was an error submitting your changes' }
			});
		}
	} catch (err) {
		console.log(err);
		yield put({
			type: ADMIN_DASHBOARD_CHANGE_ERROR,
			paylod: { message: 'There was an error submitting your changes' }
		});
	}
}

export function* adminDashboardInsert(action) {
	const { playerID } = action.payload;
	const user = yield select(selectors.user);
	const adminDashboardSearch = yield select(selectors.adminDashboardSearch);
	try {
		const data = {
			sportsID: adminDashboardSearch.sportsID,
			adminDashboardInsert: adminDashboardSearch.insert,
			playerID
		};
		const result = yield request(data, `/admin/insertinfo/${ADMIN_TOKEN}`, 'POST', user?.token);
		if (result.data.status) {
			yield put({
				type: ADMIN_DASHBOARD_INSERT_SUCCESS,
				payload: { message: 'New injury has successfully been created!' }
			});
		} else {
			yield put({
				type: ADMIN_DASHBOARD_INSERT_ERROR,
				payload: { message: 'There was an error creating a new injury' }
			});
		}
	} catch (err) {
		console.log(err);
		yield put({
			type: ADMIN_DASHBOARD_INSERT_ERROR,
			payload: { message: 'There was an error creating a new injury' }
		});
	}
}

export function* adminDashboardRunCalculations(action) {
	const user = yield select(selectors.user);
	const adminDashboardSearch = yield select(selectors.adminDashboardSearch);
	const { player } = action.payload;
	try {
		const data = {
			sportsID: adminDashboardSearch.sportsID,
			playerID: player && adminDashboardSearch.info[0].player_id
		};
		const result = yield request(data, `/admin/runcalculations/${ADMIN_TOKEN}`, 'POST', user?.token);
		if (result.data.status) {
			yield put({
				type: RUN_CALCULATIONS_SUCCESS,
				payload: { message: 'Calculations are being run in the background!' }
			});
		} else {
			yield put({
				type: RUN_CALCULATIONS_ERROR,
				payload: { message: 'There was an error starting the calculations' }
			});
		}
	} catch (err) {
		console.log(err);
		yield put({
			type: RUN_CALCULATIONS_ERROR,
			payload: { message: 'There was an error starting the calculations' }
		});
	}
}

export function* adminTeamHealthScoreNFL(action) {
	const user = yield select(selectors.user);
	try {
		const { filterDateStart = '', filterDateEnd = '', teamId = '', limit = 10, offset = 0, sortOrder = 'desc', sportsID = 1 } = action.payload;
		const data = {
			filterDateStart,
			filterDateEnd,
			teamId,
			limit,
			offset,
			sortOrder,
			sportsID: Number(sportsID)
		};
		const result = yield request(data, `/admin/fetch_teams_score/${ADMIN_TOKEN}`, 'POST', user?.token);
		if (result.data.status) {
			yield put({
				type: GET_TEAM_HEALTH_SCORE_NFL_SUCCESS,
				payload: {
					message: 'Team Health Score fetched!',
					records: result?.data?.data?.records,
					total_records: result?.data?.data?.total_records
				}
			});
		} else {
			yield put({
				type: GET_TEAM_HEALTH_SCORE_NFL_ERROR,
				payload: { message: 'There was an error fetching team health score!' }
			});
		}
	} catch (err) {
		console.log(err);
		yield put({
			type: GET_TEAM_HEALTH_SCORE_NFL_ERROR,
			payload: { message: 'There was an error fetching team health score!' }
		});
	}
}

export function* searchGames(action) {
	let result;
	const { season, season_type, week } = action.payload;
	const user = yield select(selectors.user);
	try {
		result = yield request(null, `/searchGames/${season}/${season_type}/${week}`, 'GET', user?.token);
		if (result.data.status) {
			let nfl_schedules = result?.data?.nfl?.games;
			if (nfl_schedules?.length) {
				result.data.data.nfl.games = nfl_schedules?.map((s) => {
					const localTime = toLocalTime(s?.date_time);
					s.date_time = formatDateWithTime(localTime?.date, true, localTime?.timezone);
					return s;
				});
			}
			yield put({
				type: SEARCH_GAMES_SUCCESS,
				payload: {
					message: result?.data?.message,
					nfl: result?.data?.data?.nfl
				}
			});
		} else {
			yield put({
				type: SEARCH_GAMES_ERROR,
				payload: { message: result?.data?.message }
			});
			yield put(actions.change('alertMessage.error', result?.data?.message));
		}
	} catch (error) {
		console.log(error);
		yield put({
			type: SEARCH_GAMES_ERROR,
			payload: { message: result?.data?.message }
		});
		yield put(actions.change('alertMessage.error', result?.data?.message));
	}
}

export function* submitAdminChanges(action) {
	let result;
	const user = yield select(selectors.user);
	const userActions = yield select(selectors.userActions);
	try {
		const data = {
			...action.payload
		};
		result = yield request(data, `/adminOverrides`, 'POST', user?.token);
		if (result.data.status) {
			const { season, week } = userActions?.admin_actions?.search;
			yield put({
				type: SEARCH_GAMES,
				payload: { season, week }
			});
			yield put({
				type: SUBMIT_ADMIN_CHANGES_SUCCESS
			});
			yield put(actions.change('alertMessage.message', result?.data?.message));
		} else {
			yield put({
				type: SUBMIT_ADMIN_CHANGES_ERROR,
				payload: { message: result?.data?.error }
			});
			yield put(actions.change('alertMessage.error', result?.data?.message));
		}
	} catch (error) {
		console.log(error);
		yield put({
			type: SEARCH_GAMES_ERROR,
			payload: { message: result?.data?.error }
		});
		yield put(actions.change('alertMessage.error', result?.data?.error));
	}
}

// ─── DFS "Pick of the Day" ─────────────────────────────────────────────

export function* adminGetDfsPicks() {
	const user = yield select(selectors.user);
	try {
		const result = yield request(null, '/admin/dfs-picks', 'GET', user?.token);
		const body = result?.data;
		if (body?.status === false) {
			yield put({
				type: ADMIN_GET_DFS_PICKS_ERROR,
				payload: { message: body?.message || 'Failed to load picks' }
			});
		} else {
			const picks = body?.data?.picks || body?.picks || {};
			yield put({ type: ADMIN_GET_DFS_PICKS_SUCCESS, payload: { picks } });
		}
	} catch (error) {
		// Backend not yet implemented → 404. Fall back to an empty state so the
		// admin UI is still usable. Any other error surfaces normally.
		const status = error?.response?.status;
		if (status === 404) {
			console.warn('[DFS] /admin/dfs-picks 404 — backend not implemented yet; showing empty state');
			yield put({ type: ADMIN_GET_DFS_PICKS_SUCCESS, payload: { picks: {} } });
			return;
		}
		console.log(error);
		yield put({
			type: ADMIN_GET_DFS_PICKS_ERROR,
			payload: { message: error?.message || 'Network error' }
		});
	}
}

export function* adminSaveDfsPick(action) {
	const user = yield select(selectors.user);
	try {
		const result = yield request(action.payload, '/admin/dfs-picks', 'POST', user?.token);
		const body = result?.data;
		if (body?.status === false) {
			yield put({
				type: ADMIN_SAVE_DFS_PICK_ERROR,
				payload: { message: body?.message || 'Failed to save pick' }
			});
			yield put(actions.change('alertMessage.error', body?.message));
		} else {
			const pick = body?.data?.pick || body?.pick || action.payload;
			yield put({
				type: ADMIN_SAVE_DFS_PICK_SUCCESS,
				payload: { pick, message: body?.message || 'Pick saved' }
			});
			yield put(actions.change('alertMessage.message', 'DFS pick saved'));
		}
	} catch (error) {
		console.log(error);
		yield put({
			type: ADMIN_SAVE_DFS_PICK_ERROR,
			payload: { message: error?.message || 'Network error' }
		});
		yield put(actions.change('alertMessage.error', 'Failed to save DFS pick'));
	}
}

export function* adminDeleteDfsPick(action) {
	const user = yield select(selectors.user);
	const sportsID = action.payload?.sportsID;
	try {
		const result = yield request({}, `/admin/dfs-picks/${sportsID}`, 'DELETE', user?.token);
		if (result?.data?.status !== false) {
			yield put({ type: ADMIN_DELETE_DFS_PICK_SUCCESS, payload: { sportsID } });
			yield put(actions.change('alertMessage.message', 'DFS pick removed'));
		} else {
			yield put({
				type: ADMIN_DELETE_DFS_PICK_ERROR,
				payload: { message: result?.data?.message || 'Failed to delete pick' }
			});
		}
	} catch (error) {
		console.log(error);
		yield put({
			type: ADMIN_DELETE_DFS_PICK_ERROR,
			payload: { message: error?.message || 'Network error' }
		});
	}
}

// Reuses the existing public players endpoint:
//   GET /main/players/:sportsID?league=<LEAGUE>
// The saga fetches the full roster for a sport (cached per-sport to avoid
// refetches) and filters client-side by name — matching the pattern used in
// components/Dashboard/PlayerCards.
export function* adminSearchDfsPlayers(action) {
	const user = yield select(selectors.user);
	const { sportsID, league = '', query = '' } = action.payload || {};
	const cacheKey = `${sportsID}|${league}`;
	const cached = yield select((s) => s.adminDfsPicks?.rosterBySport?.[cacheKey]);
	if (cached) {
		yield put({
			type: ADMIN_SEARCH_DFS_PLAYERS_SUCCESS,
			payload: { sportsID, league, query, roster: cached, fromCache: true }
		});
		return;
	}
	try {
		const url = `/main/players/${encodeURIComponent(sportsID)}?league=${encodeURIComponent(league)}`;
		const result = yield request(null, url, 'GET', user?.token);
		// The /main/players endpoint has shipped with a few shapes over time;
		// walk the likely keys and fall back to the first array we find.
		const d = result?.data;
		const candidates = [
			d?.data?.playerInfo,      // confirmed shape from api.insideinjuries.com
			d?.data?.players,
			d?.playerInfo,
			d?.players,
			d?.data,
			d,
			d?.result,
			d?.results,
			d?.rows
		];
		let all = candidates.find((c) => Array.isArray(c)) || [];
		if (!all.length && d && typeof d === 'object') {
			// Last resort: grab the first array-valued property we find.
			const firstArray = Object.values(d).find((v) => Array.isArray(v));
			if (firstArray) all = firstArray;
		}
		if (!all.length) {
			console.warn('[DFS] /main/players returned no array; raw shape:', d);
		}
		// Normalize the roster once and cache — subsequent keystrokes filter in-memory.
		const roster = all.map((p) => ({
			id: p.player_id || p.id,
			name: p.player_name || p.name,
			team: p.team_name || p.team,
			position: p.position,
			jersey: p.jersey,
			injury_status: p.injury_status,
			sportsID
		}));
		yield put({
			type: ADMIN_SEARCH_DFS_PLAYERS_SUCCESS,
			payload: { sportsID, league, query, roster, fromCache: false }
		});
	} catch (error) {
		if (error?.response?.status === 404) {
			yield put({ type: ADMIN_SEARCH_DFS_PLAYERS_SUCCESS, payload: { sportsID, league, query, roster: [], fromCache: false } });
			return;
		}
		console.log(error);
		yield put({
			type: ADMIN_SEARCH_DFS_PLAYERS_ERROR,
			payload: { message: error?.message || 'Search failed' }
		});
	}
}

// ── TBD Return Date sagas ────────────────────────────────────────────────────

export function* getTBDPlayers(action) {
	const sport = action?.payload?.sport || 'nba';
	const user  = yield select(selectors.user);
	try {
		const result = yield request(
			{},
			`/admin/tbd-players/${ADMIN_TOKEN}?sport=${sport}`,
			'GET',
			user?.token
		);
		const data = result.data?.data || result.data || {};
		if (data.ok) {
			yield put({
				type: GET_TBD_PLAYERS_SUCCESS,
				payload: { players: data.players || [], count: data.count || 0 }
			});
		} else {
			yield put({ type: GET_TBD_PLAYERS_ERROR, payload: { message: data.message || 'Failed to load players' } });
		}
	} catch (err) {
		console.error('[TBD] getTBDPlayers error:', err);
		yield put({ type: GET_TBD_PLAYERS_ERROR, payload: { message: 'Failed to load TBD players' } });
	}
}

export function* setPlayerReturnDate(action) {
	const { playerId, returnDate } = action.payload;
	const user = yield select(selectors.user);
	try {
		const result = yield request(
			{ return_date: returnDate },
			`/admin/player/${ADMIN_TOKEN}/${playerId}/return-date`,
			'PUT',
			user?.token
		);
		const data = result.data?.data || result.data || {};
		if (data.ok) {
			yield put({ type: SET_PLAYER_RETURN_DATE_SUCCESS, payload: { playerId, returnDate } });
		} else {
			yield put({ type: SET_PLAYER_RETURN_DATE_ERROR, payload: { message: data.message, playerId } });
		}
	} catch (err) {
		console.error(`[TBD] setPlayerReturnDate error player ${playerId}:`, err);
		yield put({ type: SET_PLAYER_RETURN_DATE_ERROR, payload: { message: 'Failed to save return date', playerId } });
	}
}

export function* clearPlayerReturnDate(action) {
	const { playerId } = action.payload;
	const user = yield select(selectors.user);
	const selectedSport = yield select((state) => state.adminTBDPlayers?.selectedSport || 'nba');
	try {
		const result = yield request(
			{},
			`/admin/player/${ADMIN_TOKEN}/${playerId}/return-date`,
			'DELETE',
			user?.token
		);
		const data = result.data?.data || result.data || {};
		if (data.ok) {
			yield put({ type: CLEAR_PLAYER_RETURN_DATE_SUCCESS, payload: { playerId } });
			yield put({ type: GET_TBD_PLAYERS, payload: { sport: selectedSport } });
		} else {
			yield put({ type: CLEAR_PLAYER_RETURN_DATE_ERROR, payload: { message: data.message, playerId } });
		}
	} catch (err) {
		console.error(`[TBD] clearPlayerReturnDate error player ${playerId}:`, err);
		yield put({ type: CLEAR_PLAYER_RETURN_DATE_ERROR, payload: { message: 'Failed to clear return date', playerId } });
	}
}
